import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseDropdownColors, BaseInquiryStatusValue } from 'base';
import { BaseCustomerUnpublishedInquiryActionsEnum } from '../../../_enums/base-customer-unpublished-inquiry-actions.enum';
import { BASE_CUSTOMER_UNPUBLISHED_INQUIRY_ACTIONS } from '../../../_consts/base-customer-unpublished-inquiry-actions.const';
import { BaseCustomerInquiryListItemType } from '../../../../inquiry/_interfaces/base-inquiry.type';

@Component({
  selector: 'base-customer-dashboard-unpublished-inquiries-list-item',
  templateUrl: './dashboard-unpublished-inquiries-list-item.component.html',
})
export class BaseCustomerDashboardUnpublishedInquiriesListItemComponent {
  @Input({ required: true }) inquiry: BaseCustomerInquiryListItemType;
  @Input({ required: true }) canPublishInquiry: boolean;
  @Input({ required: true }) state: string;
  @Output() selectInquiryAction: EventEmitter<BaseCustomerUnpublishedInquiryActionsEnum> =
    new EventEmitter<BaseCustomerUnpublishedInquiryActionsEnum>();

  inquiryStatusValue = BaseInquiryStatusValue;
  inquiryActionsEnum = BaseCustomerUnpublishedInquiryActionsEnum;
  inquiryActions: string[] = BASE_CUSTOMER_UNPUBLISHED_INQUIRY_ACTIONS;
  color: BaseDropdownColors = 'outline-danger';

  onInquiryActionSelect(action: string): void {
    this.selectInquiryAction.emit(action as BaseCustomerUnpublishedInquiryActionsEnum);
  }
}
